export default __webpack_public_path__ + "static/media/opened-disabled.9a7db61d.svg";